/** Параметри запиту списку з пункту меню та стану списку — спільні для сторінки списку й експорту CSV. */
import { buildFilter, filterFromState } from '@platform/core/lib/filterDsl';
import { stagesByFor } from '@platform/core/lib/viewSettings';
import type { IListViewState, IRecordListParams, IRecordTypeDefinition, ISavedViewDefinition } from '@platform/core/types';
import type { IMenuEntry } from '../menu/IMenuEntry';
import { quickFilterDsl } from './filters/quickFilter';

/**
 * Запит сторінки списку (чиста функція): фільтр пункту меню, умови швидкого фільтра (правило QF прототипу — завжди умовами, не пресетом:
 * quickFilterDsl), фільтр вибраного збереженого подання `saved`, умови розширених фільтрів `advanced` (фільтр-DSL), далі колонкові
 * фільтри, вкладка етапу (лише в поданні «Етапи»; поле вкладок `stageBy` — settings.stages.by чи поле пункту «За …») й теги стану (filterFromState);
 * пресет пункту меню; пошук; сортування стану, інакше подання, інакше без сортування — типовий порядок сервера (рішення 2 етапу 7, як
 * масив записів прототипу v4: створені користувачами — новіші першими, далі засіяні й зразкові — за кодом; пресети з власним порядком
 * сервер сортує сам); сторінка й розмір; ідентифікатор подання; фасети.
 */
export function listQueryOf(
  entry: Pick<IMenuEntry, 'filter' | 'preset'>, state: IListViewState, rt: IRecordTypeDefinition, saved?: ISavedViewDefinition, advanced?: string,
  stageBy: string = stagesByFor(rt),
): IRecordListParams {
  const preset = entry.preset;
  const stage = state.view === 'stages';
  return {
    filter: buildFilter([entry.filter, quickFilterDsl(state.quickFilter, rt), saved?.filter, advanced, filterFromState(stage ? state : { ...state, stage: null }, stageBy)]) || undefined,
    preset,
    q: state.search || undefined,
    sort: state.sort || saved?.sort || undefined,
    page: state.page,
    pageSize: state.pageSize,
    view: state.savedViewId ?? undefined,
    facets: true,
  };
}

/** Параметри експорту: той самий запит списку без сторінки, розміру сторінки, полів і фасетів — у файл ідуть усі записи, що відповідають списку. */
export function exportParamsOf(query: IRecordListParams): IRecordListParams {
  const { page: _page, pageSize: _pageSize, fields: _fields, facets: _facets, ...params } = query;
  return params;
}
